// extracted by css-extract-rspack-plugin
export default {"docked":"docked-If6ZOJ"};